import { call, put, select, takeLeading } from 'typed-redux-saga'
import {
	leadApi,
	RbidosLeadModel,
	STATUSES_FOR_REQUEST_LEAD,
	LeadActionsNS,
	leadActionsSlice,
	leadOneSlice,
	leadsSlice,
	leadOneSelector,
	leadsSelector,
	leadUiSelector,
} from 'Pages/lead'
import { downloadFileFromApi } from 'Helpers'
import {
	errorHandler,
	NOTIFICATION_TYPE,
	showNotificationAction,
	notifyMessageCreator,
	loadersSlice,
} from 'Modules'
import { RequestParams } from 'Models'
import { Deserialize } from 'cerialize'

function* downloadFile(action: LeadActionsNS.DownloadFile) {
	try {
		const { id, type, name } = action.payload
		const res = yield* call(leadApi.downloadFile, id, type)
		yield* call(downloadFileFromApi, res, name)
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* sendReport(action: LeadActionsNS.SendReport) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { page, per_page, query, ...fields } = action.payload
		const agreementState = yield* select(leadUiSelector.selectAgreementState)
		const params = new RequestParams(page, per_page, query, { ...fields })
		if (!fields.state && agreementState)
			params.state = STATUSES_FOR_REQUEST_LEAD[agreementState].join()

		yield* call(leadApi.sendReport, params)
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(notifyMessageCreator, 'common.report_send.success')
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

function* pushLeadSocketId(action: LeadActionsNS.PushLeadSocketId) {
	try {
		const leadFromStore = yield* select(leadOneSelector.selectOne)
		const { id, fio, notify, inn } = action.payload
		if (!notify) {
			yield* put(
				showNotificationAction({
					type: NOTIFICATION_TYPE.SUCCESS,
					message: `${fio} подтвердил(а) согласие по СМС`,
				})
			)
		}
		if (leadFromStore?.id === id || (inn && leadFromStore?.inn === inn)) {
			if (notify) yield* put(showNotificationAction(notify))
			yield* put(loadersSlice.actions.showGlobalLoader())
			const params = yield* select(leadsSelector.selectRequestParams)
			yield* put(leadsSlice.actions.getAll({ params, clear: true }))
			yield* put(loadersSlice.actions.hideGlobalLoader())
		}
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* refreshSmsRbidosLead(action: LeadActionsNS.RefreshSmsRbidosLead) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(leadApi.refreshSmsRbidosLead, action.payload)
		const res = yield* call(leadApi.getAll, new RequestParams(1))
		const lead = Deserialize(res?.entries[0], RbidosLeadModel)
		yield* put(leadOneSlice.actions.setOne(lead))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (res) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* leadActionsSaga() {
	yield* takeLeading(leadActionsSlice.actions.downloadFile.type, downloadFile)
	yield* takeLeading(leadActionsSlice.actions.sendReport.type, sendReport)
	// TODO отвязать эти экшны от текущего раздела, т.к. здесь они не юзаются
	yield* takeLeading(leadActionsSlice.actions.pushLeadSocketId.type, pushLeadSocketId)
	yield* takeLeading(leadActionsSlice.actions.refreshSmsRbidosLead.type, refreshSmsRbidosLead)
}
